import { Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react';
import { useEffect } from 'react';
import { useAppDispatch } from 'store/hooks';
import { fetchKpis } from 'store/slices/companySetting';
import APIServices from './items/APIServices';
import General from './items/General';
import Tab3 from './items/Tab3';

const data = [
    {
        tabName: 'General',
        component: <General />,
    },
    {
        tabName: 'API Services',
        component: <APIServices />,
    },
    {
        tabName: 'Tab3',
        component: <Tab3 />,
    },
];

const CompanySetting = () => {
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(fetchKpis());
    }, []);

    return (
        <Tabs className="my-tabs">
            <TabList>
                {data.map(tab => (
                    <Tab key={tab.tabName}>{tab.tabName}</Tab>
                ))}
            </TabList>

            <TabPanels>
                {data.map(tab => (
                    <TabPanel key={tab.tabName}>{tab.component}</TabPanel>
                ))}
            </TabPanels>
        </Tabs>
    );
};

export default CompanySetting;
